import { atom } from 'recoil';

const miTransitionLevelState = atom({
    key: 'miTransitionLevel',
    default: undefined
});

export default miTransitionLevelState;
